<ng-container *transloco="let t; read: 'absenceGroups'">
  <button
    kendoButton
    fillMode="solid"
    size="medium"
    rounded="medium"
    themeColor="primary"
    type="button"
    (click)="openCreate()"
    *permissionIf="'Permissions.AbsenceGroups.Create'"
    class="mbm"
  >
    {{ t("requestAbsence") }}
  </button>

  <table class="mts mbs">
    <tr>
      <td>{{ t("vacationBalance") }}:</td>
      <td>{{ t("vacationBalanceOfTotal", { balance: (employee$ | async)?.vacationBalance, total: (employee$ | async)?.vacationEntitlement }) }}</td>
    </tr>
  </table>

  <form
    [formGroup]="filterForm"
    (ngSubmit)="onFilter()"
    *permissionIf="'Permissions.AbsenceGroups.Search'"
    class="grid col3 mbm mts"
  >
    <kendo-formfield>
      <kendo-label [text]="t('from')"></kendo-label>
      <kendo-datepicker formControlName="from">
        <kendo-datepicker-messages
          [today]="t('today')"
        ></kendo-datepicker-messages>
      </kendo-datepicker>
    </kendo-formfield>

    <kendo-formfield>
      <kendo-label [text]="t('to')"></kendo-label>
      <kendo-datepicker formControlName="to">
        <kendo-datepicker-messages
          [today]="t('today')"
        ></kendo-datepicker-messages>
      </kendo-datepicker>
    </kendo-formfield>

    <kendo-formfield>
      <kendo-label [text]="t('onlyUnsigned')"></kendo-label>
      <kendo-switch
        formControlName="onlyUnsigned"
        [onLabel]="t('switch.true')"
        [offLabel]="t('switch.false')"
      ></kendo-switch>
    </kendo-formfield>

    <kendo-formfield>
      <kendo-label [text]="t('absenceType') + ' *'"></kendo-label>
      <kendo-dropdownlist
        [data]="absenceTypes$ | async"
        [defaultItem]="defaultAbsence"
        textField="name"
        valueField="id"
        [valuePrimitive]="true"
        formControlName="absenceType"
      ></kendo-dropdownlist>
    </kendo-formfield>

    <kendo-formfield>
      <kendo-label [text]="t('absenceState') + ' *'"></kendo-label>
      <kendo-dropdownlist
        [data]="absenceStatesArray"
        [defaultItem]="defaultAbsence"
        textField="name"
        valueField="id"
        [valuePrimitive]="true"
        formControlName="absenceState"
      ></kendo-dropdownlist>
    </kendo-formfield>

    <button
      kendoButton
      fillMode="solid"
      size="medium"
      rounded="medium"
      themeColor="primary"
      type="submit"
      class="mrs"
      loadingIndication="/AbsenceGroup/searchAbsenceGroup"
    >
      {{ t("search") }}
    </button>

    <button
      *ngIf="filterForm.dirty"
      kendoButton
      fillMode="outline"
      size="medium"
      rounded="medium"
      themeColor="primary"
      type="button"
      (click)="onResetFilter()"
      class="mrs"
    >
      {{ t("reset") }}
    </button>
  </form>

  <app-absence-group-grid [canWithdraw]="true"></app-absence-group-grid>

  <kendo-dialog
    *ngIf="createOpen"
    [title]="t('requestAbsence')"
    (close)="closeCreate()"
    [width]="700"
  >
    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="grid col2">
      <kendo-formfield>
        <kendo-label [text]="t('dateFrom')"></kendo-label>
        <kendo-datepicker formControlName="dateFrom">
          <kendo-datepicker-messages
            [today]="t('today')"
          ></kendo-datepicker-messages>
        </kendo-datepicker>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('isHalfDayEnd')"></kendo-label>
        <kendo-switch
          formControlName="isHalfDayEnd"
          [onLabel]="t('switch.true')"
          [offLabel]="t('switch.false')"
        ></kendo-switch>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('dateTo')"></kendo-label>
        <kendo-datepicker formControlName="dateTo">
          <kendo-datepicker-messages
            [today]="t('today')"
          ></kendo-datepicker-messages>
        </kendo-datepicker>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('isHalfDayStart')"></kendo-label>
        <kendo-switch
          formControlName="isHalfDayStart"
          [onLabel]="t('switch.true')"
          [offLabel]="t('switch.false')"
        ></kendo-switch>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('title')"></kendo-label>
        <kendo-textbox formControlName="title"></kendo-textbox>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('absenceType') + ' *'"></kendo-label>
        <kendo-dropdownlist
          [data]="absenceTypes$ | async"
          [defaultItem]="defaultAbsence"
          textField="name"
          valueField="id"
          [valuePrimitive]="true"
          formControlName="absenceType"
        ></kendo-dropdownlist>
        <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
      </kendo-formfield>

      @if(flexTimeFallbackHours(employee$ | async, tenantSettings$ | async); as fallbackHours){
        <div class="span2 warning">
          {{ t('overtimeFlexTimeFallbackHint', { hours: fallbackHours | number:'1.1-1' }) }}
        </div>
      }
    </form>

    <kendo-dialog-actions>
      <button kendoButton type="button" (click)="closeCreate()">
        {{ t("cancel") }}
      </button>
      <button
        kendoButton
        themeColor="primary"
        type="button"
        [disabled]="!formGroup.dirty || formGroup.invalid"
        (click)="onSubmit()"
        loadingIndication="/AbsenceGroup/applyAbsenceGroup"
      >
        {{ t("request") }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
</ng-container>
